module.exports = __webpack_public_path__ + "img/therm-dark.7779e7be.svg";